<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品">
              <el-select v-model="searchParams.proId" clearable @change="chgPro" placeholder="请选择">
                <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="迭代">
              <el-select v-model="searchParams.sprintId" @change="chgSprint" clearable placeholder="请选择">
                <el-option v-for="item in this.sprintListData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="teamMsg">
            <el-form-item label="团队">
              <template>
                <el-tag>{{ teamMsg.name }}</el-tag>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" v-has-permission-code-and="'0040000000000000'" size="mini"
        @click="toSave()">添加</el-button>
      <el-button type="danger" v-has-permission-code-and="'0040000000000005'" size="mini"
        @click="batchRemove()">批量删除</el-button>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column prop="name" width="160" label="会议名称"></el-table-column>
        <el-table-column prop="modeName" width="160" label="审视计划名称"></el-table-column>
        <el-table-column prop="meettm" width="160" label="会议时间"></el-table-column>
        <el-table-column prop="type" width="80" label="会议类型">
          <template slot-scope="props">
            {{
              props.row.type == 1
                ? "站会"
                : props.row.type == 2
                  ? "计划会议"
                  : props.row.type == 3
                    ? "审视会议"
                    : props.row.type == 4
                      ? "回顾会议"
                      : "评审会议"
            }}
          </template>
        </el-table-column>
        <el-table-column width="130" label="主持人">
          <template slot-scope="props">
            {{ getHostName(props.row.host) }}
          </template>
        </el-table-column>
        <el-table-column prop="participant" label="参会人"></el-table-column>
        <el-table-column prop="state" width="110" label="执行状态">
          <template slot-scope="props">
            <el-tag size="mini">{{
              props.row.state == 1
                ? "未开始"
                : props.row.state == 2
                  ? "进行中"
                  : props.row.state == 3
                    ? "未完成"
                    : props.row.state == 4
                      ? "已完成"
                      : props.row.state == 5
                        ? "已关闭"
                        : props.row.state == 6
                          ? "已挂起"
                          : "已延期"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="350px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" v-if="scope.row.state == 1 && me.name == scope.row.host"
                @click="kaishi(scope.row)">开始
              </el-button>
              <el-button size="mini" @click="toDetail(scope.$index, scope.row)">详情</el-button>

              <el-button size="mini" v-if="scope.row.state != 1" @click="toSummary(scope.$index, scope.row)">{{
                scope.row.type === 3 ? "审视记录" : "纪要" }}</el-button>
              <el-button size="mini" @click="toUpdate(scope.$index, scope.row)"
                v-has-permission-code-and="'0040000000000000'"
                v-if="'ad' == me.role || me.name == scope.row.host">编辑</el-button>
              <el-button size="mini" v-if="isShow(scope.row)" v-has-permission-code-and="'0040000000000000'"
                type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-drawer title="请填写会议纪要" size="70%" :visible.sync="drawer" :before-close="handleClose">
        <div style="padding: 30px">

          <el-row>
            <el-col :span="12">
              创建： {{ selectRow.crtm }}
            </el-col>
            <el-col :span="12">
              最后修改：<span style="color: red;"> {{ selectRow.mdtm }}</span>
              <el-button type="primary" size="mini" v-if="selectRow.state == 2 && selectRow.host == me.name"
                style="margin-left: 20px;" @click="openAddParticipantDialogZ()">添加参会人记录</el-button>
            </el-col>
          </el-row>

        </div>
        <div style="padding-left: 30px;padding-right: 30px">
          <wang-edit :isupdt="isUpdtWedit" v-model="summary"></wang-edit>
        </div>
        <br />
        <el-button @click="closeDrawer()">关 闭</el-button>
        <el-button type="primary" v-if="selectRow.state == 2 && selectRow.host == me.name" @click="saveSummary()">保
          存</el-button>
        <el-button type="success" v-if="selectRow.state == 2 && selectRow.host == me.name"
          @click="saveSummary(2)">保存并结束会议</el-button>
      </el-drawer>

      <el-drawer title="请填写站会纪要" size="70%" :visible.sync="drawerZ" :before-close="handleClose">
        <div style="padding: 30px">
          <el-row>
            <el-col :span="12">
              创建： {{ selectRow.crtm }}
            </el-col>
            <el-col :span="12">
              最后修改：<span style="color: red;"> {{ selectRow.mdtm }}</span>
              <!-- 修改后 -->
              <el-button type="primary" size="mini"
                v-if="selectRow.state == 2 && selectRow.host == me.name && availableMembersZ.length > 0"
                style="margin-left: 20px;" @click="openAddParticipantDialogZ()">添加参会人记录</el-button>
            </el-col>
          </el-row>
        </div>
        <div style="padding-left: 30px;padding-right: 30px">
          <el-table class="table" :data="zhanMeetingUsrs" stripe border height="450px">
            <el-table-column prop="un" width="130" label="参会人"> </el-table-column>

            <el-table-column prop="un" width="400" label="昨天完成了什么？">
              <template slot-scope="scope">
                <el-input type="textarea" :rows="4" v-model="scope.row.txt1" autocomplete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="un" width="400" label="今天计划做什么？">
              <template slot-scope="scope">
                <el-input type="textarea" :rows="4" v-model="scope.row.txt2" autocomplete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="un" width="400" label="当前遇到的问题？">
              <template slot-scope="scope">
                <el-input type="textarea" :rows="4" v-model="scope.row.txt3" autocomplete="off"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <br />

        <el-button @click="drawerZ = false">关 闭</el-button>
        <el-button type="primary" v-if="selectRow.state == 2 && selectRow.host == me.name" @click="saveSummary()">保存</el-button>
        <el-button type="success" v-if="selectRow.state == 2 && selectRow.host == me.name"
          @click="saveSummary(1)">保存并结束站会</el-button>
      </el-drawer>
      <!-- 添加参会人记录弹窗 -->
      <el-dialog title="添加参会人记录" :visible.sync="addParticipantDialogVisibleZ" width="600px">
        <el-form :model="newParticipantZ" label-width="100px">
          <el-form-item label="参会人">
            <el-select v-model="newParticipantZ.id" placeholder="请选择参会人" style="width: 100%">
              <el-option v-for="item in availableMembersZ" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="昨天完成了什么？">
            <el-input type="textarea" :rows="4" v-model="newParticipantZ.txt1" placeholder="请输入昨天完成的工作"></el-input>
          </el-form-item>
          <el-form-item label="今天计划做什么？">
            <el-input type="textarea" :rows="4" v-model="newParticipantZ.txt2" placeholder="请输入今天计划做的工作"></el-input>
          </el-form-item>
          <el-form-item label="当前遇到的问题？">
            <el-input type="textarea" :rows="4" v-model="newParticipantZ.txt3" placeholder="请输入当前遇到的问题"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addParticipantDialogVisibleZ = false">取 消</el-button>
          <el-button type="primary" @click="confirmAddParticipantZ()">确 定</el-button>
        </div>
      </el-dialog>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <edit ref="edit"></edit>
    <listRecord ref="listRecord"></listRecord>
  </div>
</template>
<script>
import edit from "./edit.vue";
import api from "@/api/sprint/meeting/meeting.js";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import productApi from "@/api/product/product/product.js";
import apiSBL from "@/api/sprint/sprintBacklog/sprintBacklog.js";
import listRecord from "@/views/sprint/survey_record/listRecord.vue";
import apiTeamMember from "@/api/team/teamMember/teamMember.js";

export default {
  name: "meeting",
  components: {
    edit,
    wangEdit,
    listRecord,
  },
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      drawer: false,
      drawerZ: false,
      summary: "",
      sprintListData: [], //获取到产品的sprint
      selectProd: "", //选中的产品id
      productList: [], //装载产品的数据
      page: new this.$constant.pageObj(),
      teamAndMember: [], //查询出来的团队和成员
      sprintId: "",//
      selectRowid: "",
      selectRow: {},
      selectTeam: "", //选中的团队
      teamMsg: {},
      surveyName: "",
      isUpdtWedit: false, //用于更新wangEdit
      me: {},
      zhanMeetingUsrs: [],
      addParticipantDialogVisibleZ: false,
      newParticipantZ: {
        id: '',
        un: '',
        txt1: '',
        txt2: '',
        txt3: ''
      }
    };
  },
  computed: {
    availableMembersZ() {
      
      //console.log("zhanMeetingUsrs",this.zhanMeetingUsrs,"teamAndMember",this.teamAndMember)

      const existingIds = this.zhanMeetingUsrs.map(item =>{
        if(item){
           return item.id
        }
       });

     // console.log("existingIds",existingIds)
      let  result=  this.teamAndMember.filter(member =>{
        if(member){
           return !existingIds.includes(member.id);
        }
       });
     // console.log("result",result)

      return result
    }
  },
  methods: {
    getHostName(hostId) {
      if (!hostId || !this.teamAndMember) return hostId;
      const member = this.teamAndMember.find(item => item.id == hostId);
      return member ? member.name : hostId;
    },
    isShow(row) {
      //管理员可以
      if ('ad' == this.me.role) {
        return true
      } else if (row.state == 1) {   //未开始的 
        if (this.me.name == row.host || this.me.id == row.crer) {   //未开始的主持人可以删
          return true
        }
      }
      return false
    },

    //页面初始化,获取产品数据，从浏览器获取存储的产品和sprint数据， 主要是初始化顶部搜索框条件
    init() {
      //获取产品数据并存入productData
      this.productList = this.$caches.products.get();
      const proId = this.$caches.pid.get()
      const sprid = this.$caches.sprintId.get()

      if (!this.productList) {
        //获取产品数据并存入productData
        productApi.list4Select({}, response => {
          this.productList = response.data;
          this.$caches.products.set(this.productList);
        })
      }


      if (proId) {
        //浏览器存有id则设置产品的id
        this.selectProd = proId
        this.searchParams.proId = proId;

        //console.log("浏览器存的产品id",proId);
        //查询该产品的sprint数据并存入	sprintListData
        apiSBL.getSBLByProId(this.searchParams,
          (response) => {
            this.sprintListData = response.data;
            //查看浏览器是否存有sprintid

            if (sprid) {
              //console.log("初始化有sprintID!!!!!!!");
              //如果有产品id则设置选择框的sprint
              // TODO 是否要校验这个从浏览器获取的sprintID是不是 属于浏览器存的产品的sprint
              this.sprintId = sprid;
              this.searchParams.sprintId = sprid;
              //产品与sprint设置完毕则调用list
              this.getTeamMember();
              this.getTeamMsgBySprId();
              this.list();
            } else {
              //console.log("初始化没有sprintID!!!!!!!");
              //如果浏览器没有sprintID则默认选中产品的第一个sprint  并存入浏览器
              this.sprintId = this.sprintListData[0].id;
              this.searchParams.sprintId = this.sprintListData[0].id;
              //this.$caches.sprintId.set(this.sprintListData[0].id)
              localStorage.setItem("sprintId", this.sprintListData[0].id);
              //产品与sprint设置完毕则调用list
              this.getTeamMember();
              this.getTeamMsgBySprId();
              this.list();
            }
          }
        )
      } else {
        // do nothing
      }
    },
    //获取数据
    list() {
      let params = this.$utils.merger(this.searchParams, this.page);
      this.selectTeam = "";
      if (this.searchParams.sprintId) {
        this.listLoading = true;
        api.list(params, (response) => {
          this.listData = response.data;
          if (this.listData.records && this.listData.records.length > 0) {
            this.selectTeam = this.listData.records[0].tName;
          }
          this.listLoading = false;
        });
      } else {
        this.$utils.msg.warning("请选择Sprint后查询");
        this.listData = []
      }

    },
    //获取团队成员
    getTeamMember() {
      // if (!this.teamAndMember || this.teamAndMember.length==0) {
      apiTeamMember.getTMemberBySprId(false, (response) => {
        if (response.data) {
          this.teamAndMember = response.data;
          this.$caches.teammembes.set(this.teamAndMember);
        }
      });
      // }
    },
    //获取团队信息
    getTeamMsgBySprId() {
      apiTeamMember.getTeamMsgBySprId(
        { sprintId: this.sprintId },
        (response) => {
          this.teamMsg = response.data;
        }
      );
    },
    //改变状态
    gaibianstate(row) {
      let e = window.event;
      console.log(e);
      console.log(e.target.innerText);
      this.confirmLoading = true;

      if (e.target.innerText === "进行中") {
        this.$utils.confirm.warning("提示", "确定改变状态么？", () => {
          let parameter = { id: row.id, type: row.type, state: "2" };
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
              this.confirmLoading = false;
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        });
      }
      if (e.target.innerText === "未完成") {

        this.$utils.confirm.warning("提示", "确定改变状态么？", () => {
          let parameter = { id: row.id, type: row.type, state: "3" };
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
              this.confirmLoading = false;
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        });
      }
      if (e.target.innerText == "已完成") {
        this.$utils.confirm.warning("提示", "确定改变状态么？", () => {
          let parameter = { id: row.id, type: row.type, state: "4" };
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
              this.confirmLoading = false;
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        });
      }
      if (e.target.innerText === "已关闭") {
        this.$utils.confirm.warning("提示", "确定改变状态么？", () => {
          let parameter = { id: row.id, type: row.type, state: "5" };
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
              this.confirmLoading = false;
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        });
      }
      if (e.target.innerText == "已挂起") {
        this.$utils.confirm.warning("提示", "确定改变状态么？", () => {
          let parameter = { id: row.id, type: row.type, state: "6" };
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
              this.confirmLoading = false;
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        });
      }
      if (e.target.innerText === "已延期") {

        this.$utils.confirm.warning("提示", "确定改变状态么？", () => {
          let parameter = { id: row.id, type: row.type, state: "7" };
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
              this.confirmLoading = false;
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        });
      }
    },
    //开始按钮改变为"进行中"状态
    kaishi(row) {
      this.confirmLoading = true;

      this.$utils.confirm.warning("提示", "确定开始吗？", () => {
        let parameter = { id: row.id, type: row.type, state: "2" };
        api.update(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
            this.confirmLoading = false;
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    //去添加
    toSave() {
      this.$refs.edit.open(
        {
          sprintId: this.sprintId,
          teamMembers: this.teamAndMember,
        },
        "Sprint添加会议"
      );
    },
    //去编辑
    toUpdate(index, row) {
      let editParameter = {
        id: row.id,
        teamMembers: this.teamAndMember,
      };
      this.$refs.edit.open(editParameter, "编辑会议");
    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id,
        sprintId: this.sprintId,           // 补充 sprintId
        teamMembers: this.teamAndMember,   // 补充团队成员
      };
      this.$refs.edit.open(detailParameter, "会议详情", true);
    },
    //会议纪要
    toSummary(index, row) {
      //如果是审视会议则打开审视记录窗口
      console.log("会议纪要",row)
      if (row.type == 3) {
        this.$refs.listRecord.open1(
          { meetingId: row.id },
          "审视会议:" + row.name + " 的审视记录",
          "80%"
        );
      } else if (row.type == 1) {
        this.selectRowid = row.id;
        this.selectRow = row

        // init
        this.zhanMeetingUsrs = [];
        if (row.summary) {
          //仅取数据库
          this.zhanMeetingUsrs = JSON.parse(row.summary)

        } else {
          //新建，需要构建
          let arrs = row.participant.split(",")
          arrs.forEach(v => {
            this.zhanMeetingUsrs.push({ un: v })
          });
          this.zhanMeetingUsrs.push({ un: row.host })
        }

        this.drawerZ = true;

      } else {
        //根据id查询纪要
        this.selectRowid = row.id;
        this.selectRow = row
        api.selectSummary({ id: row.id }, (res) => {
          this.summary = res.msg;
          if (this.summary) {
            this.isUpdtWedit = true
            setTimeout(() => {
              this.isUpdtWedit = false
            }, 100)
          }

        });
        this.drawer = true;
      }
    },
    //添加或修改纪要
    saveSummary(flag) {

      console.log("this.summary", this.summary);

      let summary = this.summary

      if (this.selectRow.type * 1 == 1) {   //站会

        //处理会议纪要
        summary = JSON.stringify(this.zhanMeetingUsrs)
      }

      if (flag) {  //结束会议
        this.selectRow.state = 4
      }

      api.update(
        {
          id: this.selectRowid,
          summary: summary,
          state: this.selectRow.state
        },
        (res) => {
          this.$utils.msg.success("修改会议纪要成功");
          this.list()
          if (flag && flag == 1) {  //结束站会
            this.drawerZ = false
          } else if (flag && flag == 2) {  //结束会议
            this.drawer = false
          }
        },
        (err) => {
          this.$utils.msg.warning("修改会议纪要成功失败");
        }
      );
    },
    //关闭纪要弹窗
    closeDrawer() {
      this.drawer = false;
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //产品改变
    chgPro(val) {
      this.$caches.pid.set(val);
      this.selectProd = val;
      this.searchParams.proId = val;

      if (val) {
        apiSBL.getSBLByProId(this.searchParams, (response) => {
          this.sprintListData = response.data;
          if (response.data.length !== 0) {
            this.searchParams.sprintId = this.sprintListData[0].id;
            this.sprintId = this.sprintListData[0].id;
            this.$caches.sprintId.set(this.sprintListData[0].id)
            this.getTeamMember();
            this.getTeamMsgBySprId();
            this.list();
          } else {
            this.list();
            this.$caches.sprintId.remove()
            this.searchParams.sprintId = "";
            this.sprintId = "";
          }
        });
      }
    },
    //sprint改变
    chgSprint(val) {
      this.sprintId = val;
      this.searchParams.sprintId = val;
      this.$caches.sprintId.set(val)
      this.teamAndMember = [];
      this.teamMsg = null

      if (val) {
        this.getTeamMember();
        this.getTeamMsgBySprId();
        this.list();
      }

    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search() {
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = {};
    },
    handleClose(done) {
      done();
    },
    // 打开添加参会人记录弹窗
    openAddParticipantDialogZ() {
      this.newParticipantZ = {
        id: '',
        un: '',
        txt1: '',
        txt2: '',
        txt3: ''
      };
      this.addParticipantDialogVisibleZ = true;
    },
    // 确认添加参会人记录
    confirmAddParticipantZ() {
      if (!this.newParticipantZ.id) {
        this.$utils.msg.warning("请选择参会人");
        return;
      }
      const member = this.teamAndMember.find(item => item.id == this.newParticipantZ.id);
      this.newParticipantZ.un = member ? member.name : '';
      this.zhanMeetingUsrs.push({
        id: this.newParticipantZ.id,
        un: this.newParticipantZ.un,
        txt1: this.newParticipantZ.txt1,
        txt2: this.newParticipantZ.txt2,
        txt3: this.newParticipantZ.txt3
      });
      this.addParticipantDialogVisibleZ = false;
    },
  },
  mounted() {
    this.me = this.$caches.user.get();
    this.init();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

/deep/.w-e-text-container {
  height: 600px !important;
  /*!important是重点，因为原div是行内样式设置的高度300px*/
}
</style>
